import { ApiService } from '../../services/api_service';
import * as config from '../../wips.config.js';
import { ContextService } from '../../services/context_service';
import { getRoutingFromLocationHash } from '../../main/functions/locationHash';
import { i18n } from '../../i18n/i18n';
import { lazyInject } from '../../services/inversify';
import { Navigation } from '../../main/Navigation';
import React from 'react';
import style from './BreadcrumbNavigation.less';
import { WVideoIcon } from '../../core/elements/WVideoIcon';

export interface BreadcrumbNavigationProps {
    data: any;
    id: number;
    onRoutingChange: (routing: any) => void;
}

export interface BreadcrumbNavigationState {
    node: any;
    nodePath: any[];
    videoInfo: any;
}

export class BreadcrumbNavigation extends React.Component<BreadcrumbNavigationProps, BreadcrumbNavigationState> {

    constructor(props: any) {
        super(props);
        this.state = {
            node: {},
            nodePath: [],
            videoInfo: null,
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount(): void {
        this.init();
    }

    componentDidUpdate(prevProps: any): void {
        const locationRouting: any = getRoutingFromLocationHash(window.location.hash, this.contextService) || {};

        if (this.props.id !== prevProps.id) {
            this.init();
        }

        if (locationRouting.path && JSON.stringify(locationRouting) !== JSON.stringify(this.state.node)) {
            this.setState({ node: locationRouting }, () => this.init());
        }
    }

    getVideoForNodePath(nodePath: any[]): any {
        // console.log('NodePath:', nodePath);
        if (nodePath.find((node: any) => node.name === 'Energiekosten-Projektion')) {
            return { url: 'videos/eTool_02_Projektionstool.mp4', name: 'Energiekosten - Projektion' };
        } else if (nodePath.find((node: any) => node.name === 'Energie-Cockpit')) {
            return { url: 'videos/eTool_05_Energiecockpit.mp4', name: 'Energie - Cockpit' };
        } else if (nodePath.find((node: any) => node.name === 'Datenauswertung')) {
            return { url: 'videos/eTool_06_Datenauswertung_detailliert.mp4', name: 'Detaillierte Auswertung' };
        }
    }

    init(): void {
        const locationRouting: any = getRoutingFromLocationHash(window.location.hash, this.contextService) || { path: { selectedMenu: this.props.id } };
        const nodePath: any[] = (new Navigation(this.props.data, this.apiService, this.contextService)).getNodePath(locationRouting) || [];
        const videoInfo: any = this.getVideoForNodePath(nodePath);
        this.setState({ nodePath, videoInfo }, () => console.info('INIT-BREADCRUMB:', this.props.id, nodePath, this.state.node, this.state.videoInfo));
    }

    onRoutingChange(data: any): void {
        this.setState({ node: data || {} }, () => this.props.onRoutingChange(this.state.node));
    }

    render(): JSX.Element {
        const { videoInfo } = this.state;
        // console.log('Node-Video:', videoInfo);
        return <>
            {videoInfo && config?.enableVideos &&
                <div
                    className={style.startBox}
                    style={{
                        textAlign: 'right', left: 275, width: 'auto', right: 0, margin: 0, marginTop: 9, padding: 0, paddingRight: 100,
                        position: 'absolute', backgroundColor: 'transparent', boxShadow: 'none'
                    }}
                >
                    <WVideoIcon
                        videoUrl={videoInfo.url}
                        title={i18n(videoInfo.name, 'sys')}
                    />
                </div>
            }
            <div className={style.breadcrumb_navigation}>
                {this.state.nodePath.map((item: any, index: number) =>
                    <div
                        key={`path-${index}`}
                        // onClick={() => this.onRoutingChange({ path: item.path || {}, entities: item.entities || [] })}
                    >
                        {item.name}
                    </div>
                )}
            </div>
        </>;
    }
}
